import 'svelte/internal/disclose-version';

Callback[$.FILENAME] = 'src/web/concepts/callback.svelte';

import * as $ from 'svelte/internal/client';
import SlotPicker from "./slot_picker.svelte";

var root = $.add_locations(
	$.from_html(
		`
    <p class="font-display text-4xl md:text-6xl font-semibold tracking-tight"> </p>
  `,
		1
	),
	Callback[$.FILENAME],
	[[16, 4]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
          <button type="button"> </button>
        `,
		1
	),
	Callback[$.FILENAME],
	[[26, 10]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-4xl md:text-6xl font-semibold tracking-tight">Leave your number.<br/>We call you.</h1>
    <form class="flex flex-col gap-6">
      <div class="grid md:grid-cols-2 gap-4">
        <input class="field text-2xl" placeholder="Your name" required=""/>
        <input class="field text-2xl" type="tel" placeholder="+33 6 12 34 56 78" required=""/>
      </div>
      <div class="flex flex-wrap gap-2">
        <!>
      </div>
      <!>
      <button class="btn self-start"> </button>
    </form>
  `,
		1
	),
	Callback[$.FILENAME],
	[
		[18, 4, [[18, 97]]],
		[19, 4, [[20, 6, [[21, 8], [22, 8]]], [24, 6], [30, 6]]]
	]
);

var root_3 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-3xl flex flex-col gap-8">
  <!>
</div>`,
		1
	),
	Callback[$.FILENAME],
	[[14, 0]]
);

function Callback($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Callback);

	const options = ["Right now", "In an hour", "Tomorrow morning", "Pick a time"];
	let when = $.tag($.state($.proxy(options[0])), 'when');
	let slot = $.tag($.state(null), 'slot');
	let phone = $.tag($.state(""), 'phone');
	let name = $.tag($.state(""), 'name');
	let done = $.tag($.state(false), 'done');
	const moment = $.tag($.derived(() => $.strict_equals($.get(when), "Pick a time") ? $.get(slot) : $.get(when).toLowerCase()), 'moment');
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_3();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var p = $.sibling($.first_child(fragment_1));
			var text = $.only_child(p);

			$.next();
			$.template_effect(() => $.set_text(text, `We'll call ${$.get(name) ?? ''} on ${$.get(phone) ?? ''}, ${$.get(moment) ?? ''}.`));
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_2();
			var form = $.sibling($.first_child(fragment_2), 3);
			var div_1 = $.sibling($.child(form));
			var input = $.sibling($.child(div_1));

			$.remove_input_defaults(input);

			var input_1 = $.sibling(input, 2);

			$.remove_input_defaults(input_1);
			$.next();
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var node_1 = $.sibling($.child(div_2));

			$.add_svelte_meta(
				() => $.each(node_1, 17, () => options, $.index, ($$anchor, o) => {
					$.next();

					var fragment_3 = root_1();
					var button = $.sibling($.first_child(fragment_3));
					var text_1 = $.only_child(button, true);

					$.next();

					$.template_effect(() => {
						$.set_class(button, 1, $.clsx([
							"px-4 py-2 border-2 border-ink font-semibold transition-colors",
							$.strict_equals($.get(when), $.get(o)) ? "bg-ink text-accent" : "hover:bg-ink/10"
						]));

						$.set_text(text_1, $.get(o));
					});

					$.delegated('click', button, function click() {
						return $.set(when, $.get(o), true);
					});

					$.append($$anchor, fragment_3);
				}),
				'each',
				Callback,
				25,
				8
			);

			$.next();
			$.reset(div_2);

			var node_2 = $.sibling(div_2, 2);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_4 = $.comment();
					var node_3 = $.first_child(fragment_4);

					$.add_svelte_meta(
						() => SlotPicker(node_3, {
							get value() {
								return $.get(slot);
							},

							set value($$value) {
								$.set(slot, $$value, true);
							}
						}),
						'component',
						Callback,
						29,
						34,
						{ componentTag: 'SlotPicker' }
					);

					$.append($$anchor, fragment_4);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.strict_equals($.get(when), "Pick a time")) $$render(consequent_1);
					}),
					'if',
					Callback,
					29,
					6
				);
			}

			var button_1 = $.sibling(node_2, 2);
			var text_2 = $.only_child(button_1);

			$.next();
			$.reset(form);
			$.next();

			$.template_effect(() => {
				button_1.disabled = $.strict_equals($.get(when), "Pick a time") && !$.get(slot);
				$.set_text(text_2, `Call me ${$.get(moment) ?? "" ?? ''}`);
			});

			$.event('submit', form, function submit(e) {
				e.preventDefault();
				$.set(done, true);
			});

			$.bind_value(
				input,
				function get() {
					return $.get(name);
				},
				function set($$value) {
					$.set(name, $$value);
				}
			);

			$.bind_value(
				input_1,
				function get() {
					return $.get(phone);
				},
				function set($$value) {
					$.set(phone, $$value);
				}
			);

			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(done)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Callback,
			15,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Callback = $.hmr(Callback);

	import.meta.hot.accept((module) => {
		Callback[$.HMR].update(module.default);
	});
}

export default Callback;

$.delegate(['click']);